export default __webpack_public_path__ + "scene02fdb526.jpg";